import fetch from "auth/FetchInterceptor";

const CoursesService = {};

const coursesPrefix = "/course";

CoursesService.getCourses = async () =>
    await fetch(`${coursesPrefix}/getAll`, {
        method: "GET",
    });

CoursesService.getCourse = async (id) =>
    await fetch(`${coursesPrefix}/getById/${id}`, {
        method: "GET",
    });

CoursesService.createCourse = async (data) =>
    await fetch(`${coursesPrefix}/create`, {
        method: "POST",
        data,
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });

CoursesService.updateCourse = async (id, data) =>
    await fetch(`${coursesPrefix}/update/${id}`, {
        method: "PATCH",
        data,
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });

CoursesService.updateCourseStatus = async (id, state) =>
  await fetch(`${coursesPrefix}/${id}/state`, {
    method: "PATCH",
    data: { state },
  });

CoursesService.deleteCourse = async (id) =>
    await fetch(`${coursesPrefix}/deleteById/${id}`, {
        method: "DELETE",
    });

// Set which formations contain this course (link stored on the formation side)
CoursesService.setCourseFormations = async (id, formationIds) =>
    await fetch(`${coursesPrefix}/${id}/formations`, {
        method: "PUT",
        data: { formationIds },
    });

export default CoursesService;
